import { setListingStateHidden } from './listingState';
import { SIDEBAR_ANIMATION_DURATION } from '../../../ListingDesktop/constants/animation';
import { TThunkAction } from '../../types/redux';
import { promisifiedTimeout } from '../../utils/promisifiedTimeout';
import { invalidateListingOffersByIdsRequests } from '../listingOffers/listingOffersByIdsRequestGuard';
import { resetListingOffers } from '../listingOffers/resetListingOffers';

let closeController: AbortController | null = null;

export const cancelPendingClose = () => {
  closeController?.abort();
};

export const closeDesktopListing = (): TThunkAction => dispatch => {
  cancelPendingClose();
  invalidateListingOffersByIdsRequests();
  closeController = new AbortController();

  dispatch(setListingStateHidden());

  promisifiedTimeout(() => dispatch(resetListingOffers()), SIDEBAR_ANIMATION_DURATION, {
    signal: closeController.signal,
  }).catch(() => {
    // отменено через cancelPendingClose
  });
};
